import axios from 'axios';
import router from '@/router';
import {Message} from 'element-ui'

axios.defaults.withCredentials = true

const http = {
	get(url, callback) {
		axios
			.get(url)
			.then((response) => {
				this.dealResult(response, callback);
			})
			.catch((error) => {
				console.log(error);
			});
	},
  download(url) {
    let promise = new Promise((resolve, reject) => {
      axios
        .get(url, {
          responseType: 'blob',
        }).then(response => {
          if (!response || !response.data) return  reject();
          if(response.data.type==='application/json')return  reject();
          var responseFilename = null;
          try { responseFilename = response.headers['content-disposition'].split('=')[1];} catch (e) {}
          var fileName = responseFilename || 'download-' + new Date().getTime()+'.xls';
          let blob = new Blob([response.data]);
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
    return promise;
  },
  fileDownload(url,name) {
    let promise = new Promise((resolve, reject) => {
      axios
        .get(url, {
          responseType: 'blob',
        }).then(response => {
        if (!response || !response.data) return  reject();
        if(response.data.type==='application/json')return  reject();
        var responseFilename = null;
        try { responseFilename = response.headers['content-disposition'].split('=')[1];} catch (e) {}
        var fileName = responseFilename || name + '.docx';
        let blob = new Blob([response.data]);
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
    return promise;
  },
  getFile(url, callback) {
    axios
      .get(url,{
        responseType: 'blob',
      })
      .then((response) => {
        this.dealResult(response, callback);
      })
      .catch((error) => {
        console.log(error);
      });
  },
	post(url, data, callback) {
    let self = this
    axios
      .post(url, require('qs').stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      })
      .then((response) => {
        self.dealResult(response, callback);
      })
      .catch((error) => {
        self.dealResult(error, callback);
        console.log(error);
      });
  },
  postPoster(url, data, callback) {
	  // 上传海报做file流上传
    let self = this
    axios
      .post(url,  data, {
        headers: {
          'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq',
        }
      })
      .then((response) => {
        self.dealResult(response, callback);
      })
      .catch((error) => {
        self.dealResult(error, callback);
        console.log(error);
      });
  },
  postJson(url, data, callback) {
    let self = this
    axios
      .post(url, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then((response) => {
        self.dealResult(response, callback);
      })
      .catch((error) => {
        self.dealResult(error, callback);
        console.log(error);
      });
  },
	postMulti(url, form, callback) {
		axios
			.post(url, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then((response) => {
				this.dealResult(response, callback)
			}).catch((error) => {
				console.log(error)
			})
	},
	dealResult(response, callback) {
		// console.log(response, 55555)
		if (response.data && response.data.code === 1) {
			let bool = true
			try { // 当前是登录页面，不跳转
				bool = !router.history.current.path.startsWith('/login.html')
			} catch (e) {}
			if(bool){
				Message.error(response.data.description || response.data.message || '请先登录');
				router.push("/login.html");
			}else{
				callback(response);
			}
		} else {
			callback(response);
		}
	}
}

export default http;



// WEBPACK FOOTER //
// ./src/http/index.js